module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag3-licensing.135d9927.gif";